import React, {
  ChangeEvent,
  createContext,
  PropsWithChildren,
  ReactNode,
  useContext,
  useState,
} from 'react';

interface SearchableProviderProps {
  children: (onChange: (value: string) => void) => ReactNode;
}

const SearchableContext = createContext({
  search: '',
});

export function useSearch() {
  return useContext(SearchableContext);
}

export const SearchableProvider = (props: PropsWithChildren<SearchableProviderProps>) => {
  const { children } = props;
  const [search, setSearch] = useState('');

  const onChange = (value) => {
    setSearch(value);
  };

  return (
    <SearchableContext.Provider value={{ search }}>{children(onChange)}</SearchableContext.Provider>
  );
};
